import { Component, VModel, Vue, Prop, Watch } from 'vue-property-decorator';
import { NOTIFICATION } from '@/constants';
import { UserDTO, UserRewardRequestInfoDTO } from '@/models';
import { updateCurrentUserRewardRequestInfo } from '@/services';
import { isValidNumericInputKey } from '@/helpers';

@Component
export default class ShippingInfoDialog extends Vue {
  @VModel() shippingInfoDialogShown!: boolean;
  @Prop() currentUserRewardRequestInfo!: UserRewardRequestInfoDTO;
  private userRewardRequestInfo: UserRewardRequestInfoDTO = {} as UserRewardRequestInfoDTO;

  get currentUser(): UserDTO {
    return this.$store.getters['app/currentUser'];
  }

  get isDataNotValid(): boolean {
    const { phone, address } = this.userRewardRequestInfo || {};
    return !phone || !address;
  }

  onPhoneKeyDown(event: KeyboardEvent): void {
    if (!isValidNumericInputKey(event)) {
      event.preventDefault();
    }
  }

  @Watch('shippingInfoDialogShown')
  onDialogOpen(): void {
    this.userRewardRequestInfo = { ...this.currentUserRewardRequestInfo };
  }

  onCancelChange(): void {
    this.shippingInfoDialogShown = false;
  }

  onConfirmChange(): void {
    if (this.isDataNotValid) {
      return;
    }
    const updatedData = {
      ...this.userRewardRequestInfo,
      userId: this.currentUser.id
    };
    updateCurrentUserRewardRequestInfo(updatedData).then(({ data }) => {
      const notificationData = {
        showing: true,
        type: '',
        title: '',
        content: [],
        icon: '',
        multiline: false,
        height: 0
      };
      if (data) {
        notificationData.type = NOTIFICATION.TYPE.success;
        notificationData.title = NOTIFICATION.TEXT.updateShippingInfoSuccess;
        notificationData.icon = NOTIFICATION.ICON.success;
        this.shippingInfoDialogShown = false;
        this.$emit('onConfirmChanged', updatedData);
      } else {
        notificationData.type = NOTIFICATION.TYPE.error;
        notificationData.title = NOTIFICATION.TEXT.updateShippingInfoFailed;
        notificationData.icon = NOTIFICATION.ICON.error;
      }
      this.$store.commit('notification/setNotification', notificationData);
    });
  }
}
